import React from "react";
import { useContext } from "react";
import { AuthContext } from "../../../Contexts/AuthContext";
import { roles } from "../../../Config/Roles";
import MasterRole from "./MasterRole";
import OtherRoles from "./OtherRoles";

const InvoicesUnfiscalizedBills = () => {
   const { roleId } = useContext(AuthContext);
   const { master } = roles;
   return master === Number(roleId) ? <MasterRole /> : <OtherRoles />;
};

export default InvoicesUnfiscalizedBills;
